(() => {
  'use strict';
  const root=document.querySelector('[data-dg-lab-tool="system-benchmark"]');
  if(!root) return;
  if(root.dataset['dgLabSystemBenchmarkInitialized'] === 'true') return;
  root.dataset['dgLabSystemBenchmarkInitialized'] = 'true';
  const runButton=root.querySelector('#run');
  const status=root.querySelector('.status');
  const scoreElement=root.querySelector('#score');
  const averageElement=root.querySelector('#average-score');
  const countElement=root.querySelector('#run-count');
  const cpuElement=root.querySelector('#cpu');
  const canvasElement=root.querySelector('#canvas');
  const ratingElement=root.querySelector('#rating');
  const warning=root.querySelector('#benchmark-warning');
  let runCount=0,accumulatedScore=0,running=false;
  function getRating(score){ return score>500?'Alto':score>250?'Medio':'Básico'; }
  function isLikelyMobile(){ return matchMedia('(pointer: coarse)').matches || Math.min(innerWidth,innerHeight)<760; }
  async function runBenchmark(){
    if(running) return;
    const mobile=isLikelyMobile();
    const ok=confirm(mobile?'Este benchmark puede consumir CPU y batería durante unos segundos. Se ejecutará una versión prudente para móvil. ¿Continuar?':'Este benchmark puede elevar temporalmente el uso de CPU y Canvas del navegador. ¿Continuar?');
    if(!ok) return;
    running=true;
    runButton.disabled=true;
    runButton.textContent='Ejecutando…';
    status.textContent='Benchmark en curso…';
    if(warning) warning.textContent='La prueba ya iniciada puede tardar unos segundos en responder. Resultado orientativo de JavaScript y Canvas del navegador.';
    try{
      await new Promise(resolve=>requestAnimationFrame(resolve));
      let start=performance.now();
      let value=0;
      const cpuIterations=mobile?7e6:2e7;
      for(let i=0;i<cpuIterations;i++) value=(value+i)%999983;
      const cpuTime=performance.now()-start;
      const canvas=root.querySelector('#bench');
      const context=canvas.getContext('2d');
      if(!context) throw new Error('Canvas no disponible');
      context.clearRect(0,0,canvas.width,canvas.height);
      start=performance.now();
      const drawIterations=mobile?12000:30000;
      for(let i=0;i<drawIterations;i++){
        context.fillStyle=`hsl(${i%360} 70% 50%)`;
        context.fillRect(Math.random()*canvas.width,Math.random()*canvas.height,4,4);
      }
      const canvasTime=performance.now()-start;
      const normalization=mobile?42000:100000;
      const score=Math.round(normalization/(cpuTime+canvasTime));
      runCount+=1;
      accumulatedScore+=score;
      const averageScore=Math.round(accumulatedScore/runCount);
      cpuElement.textContent=cpuTime.toLocaleString('es-ES',{maximumFractionDigits:0});
      canvasElement.textContent=canvasTime.toLocaleString('es-ES',{maximumFractionDigits:0});
      scoreElement.textContent=score.toLocaleString('es-ES');
      averageElement.textContent=averageScore.toLocaleString('es-ES');
      countElement.textContent=runCount.toLocaleString('es-ES');
      ratingElement.textContent=getRating(averageScore);
      status.textContent='Completado';
      if(warning) warning.textContent='Puntuación orientativa de JavaScript y Canvas del navegador.';
    }catch(error){
      status.textContent='No disponible';
      if(warning) warning.textContent='La prueba se detuvo de forma segura. Puedes intentarlo de nuevo.';
    }finally{
      running=false;
      runButton.disabled=false;
      runButton.textContent='Reiniciar';
    }
  }
  runButton.addEventListener('click',runBenchmark);
  addEventListener('pagehide',()=>{ running=false; },{once:true});
})();
